import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const Field = ({ label, children }) => <div><Label>{label}</Label>{children}</div>;

export function RentalFields({ formData, setFormData, vehicles, excludeId }) {
  const [fetched, setFetched] = useState([]);
  useEffect(() => { if (!vehicles) api.get('/vehicles').then((r) => setFetched(r.data?.data || [])).catch(() => {}); }, [vehicles]);
  const set = (k) => (e) => setFormData({ ...formData, [k]: e.target.value });
  const skip = excludeId || formData.id;
  const others = (vehicles || fetched).filter((v) => v.id !== skip && v.ownership_type !== 'Kiralık');
  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50/60 dark:bg-sky-950/20 dark:border-sky-900 p-3 space-y-3" data-testid="rental-fields">
      <p className="text-sm font-semibold text-sky-800 dark:text-sky-300">Kiralık araç bilgileri</p>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Hangi aracın yerine geldi?">
          <Select value={formData.replaces_vehicle_id || 'none'} onValueChange={(v) => setFormData({ ...formData, replaces_vehicle_id: v === 'none' ? '' : v })}>
            <SelectTrigger data-testid="rental-replaces-select"><SelectValue placeholder="Araç seçin" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">— Yok —</SelectItem>
              {others.map((v) => <SelectItem key={v.id} value={v.id}>{v.license_plate}{v.brand ? ` · ${v.brand}` : ''}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Kiralama firması">
          <Input value={formData.rental_company || ''} onChange={set('rental_company')} placeholder="ör. Hertz" data-testid="rental-company-input" />
        </Field>
        <Field label="Kiralama tarihi">
          <Input type="date" value={formData.rental_start_date || ''} onChange={set('rental_start_date')} data-testid="rental-start-input" />
        </Field>
        <Field label="Ne zaman gidecek? (dönüş)">
          <Input type="date" value={formData.rental_end_date || ''} onChange={set('rental_end_date')} data-testid="rental-end-input" />
        </Field>
        <Field label="Aylık ücret (€)">
          <Input type="number" step="0.01" min="0" value={formData.rental_monthly_fee ?? ''} onChange={set('rental_monthly_fee')} data-testid="rental-monthly-input" />
        </Field>
        <Field label="Günlük ücret (€)">
          <Input type="number" step="0.01" min="0" value={formData.rental_daily_fee ?? ''} onChange={set('rental_daily_fee')} data-testid="rental-daily-input" />
        </Field>
      </div>
    </div>
  );
}
